import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const CreateAccountButton = () => {
  const { loading } = useSelector(
    ({
      pages: {
        signup: { loading },
      },
    }) => ({
      loading,
    })
  )

  return (
    <div>
      {loading ? (
        <button className="ui fluid large disabled button mt4">Continue to your account</button>
      ) : (
        <button className="ui fluid large primary submit button mt4">
          Continue to your account
        </button>
      )}
    </div>
  )
}

CreateAccountButton.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
}

export default CreateAccountButton



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/CreateAccountButton/index.js